// extracted by mini-css-extract-plugin
export default {"app":"App_app__Gnr+6","page":"App_page__bcHNp"};